module.exports = __webpack_public_path__ + "img/icon-floor.2e67e4aa.svg";